export default {"src":"/_next/static/media/world_white.0fd744a8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};